import React from 'react';

const Testimonial = ({ name, company, quote, image }) => {
    return (
        <div className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300">
            <div className="flex items-center mb-4">
                <div className="flex-shrink-0 w-12 h-12 mr-4">
                    <img
                        src={image}
                        alt={name}
                        className="w-full h-full rounded-full object-cover"
                        onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = 'https://via.placeholder.com/80?text=頭像';
                        }}
                    />
                </div>
                <div>
                    <p className="font-semibold">{name}</p>
                    <p className="text-gray-600 text-sm">{company}</p>
                </div>
            </div>

            <div className="mb-4">
                {[...Array(5)].map((_, i) => (
                    <span key={i} className="text-yellow-400">★</span>
                ))}
            </div>

            <p className="text-gray-600 italic">"{quote}"</p>
        </div>
    );
};

export default Testimonial;